// @flow

import React from "react";
import { GSGrid, Icons, Button, Text, View } from "@components";
import { localize } from "redux-i18n";
import classNames from "classnames";

import { enabledReports } from "../../constants/reports";

type Props = $Exact<{
  reports: Array<Object>,
  runReport: Function,
  toggleHelpPanel?: Function,
  title: string,
  ...PropsFromLocalize,
}>;
type ComponentState = $Exact<{
  showPerPage: number,
  startShowIdx: number,
}>;

export class StandartReportsLayout extends React.Component<Props, ComponentState> {
  state = {
    showPerPage: 4,
    startShowIdx: 0,
  };

  filterReportName = (name: string) => {
    return name.replace("% ", "").replace(/[a-zA-Z]+\:\s/, "");
  };

  get reports() {
    return this.props.reports.map((r: Object) => {
      return {
        ...r,
      };
    });
  }

  get allowedReports() {
    const reportNames = Object.keys(enabledReports);
    return this.reports.filter((r: Object) => {
      return reportNames.includes(r.name);
    });
  }

  get coverText() {
    if (window.location.pathname.includes("focus-lists/department")) {
      return {
        ...enabledReports,
        "Top 25 Mental Health Absences in Last 12 Months":
          "DFL_TOP_MENTAL_HEALTH_ABSENCES_LAST_YEAR",
      };
    }
    return enabledReports;
  }

  get paginatedReports() {
    const startShowIdx = this.state.startShowIdx;
    return this.allowedReports.map((r: Object, idx: number) => {
      return {
        ...r,
        hidden: idx > startShowIdx + 3 || idx < startShowIdx,
      };
    });
  }

  nextPage = () => {
    const { showPerPage, startShowIdx } = this.state;
    const totalItems = this.allowedReports.length;
    this.setState({
      startShowIdx: startShowIdx + showPerPage >= totalItems ? startShowIdx : startShowIdx + 1,
    });
  };
  prevPage = () => {
    const { showPerPage, startShowIdx } = this.state;
    this.setState({
      startShowIdx: startShowIdx <= 0 ? startShowIdx : startShowIdx - 1,
    });
  };

  render() {
    const { showPerPage, startShowIdx } = this.state;
    return (
      <View gap={6}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <h4>{this.props.title}</h4>
            {this.props.toggleHelpPanel && (
              <Button
                className="ml-3 mb-1"
                onClick={this.props.toggleHelpPanel}
                materialIcon="help"
              >
                {this.props.t("HELP")}
              </Button>
            )}
          </div>
          <div className="d-flex flex-column ">
            {showPerPage < this.allowedReports.length && (
              <div className="d-flex justify-content-end pr-3 mb-2">
                <span className="material-icons fs-34 cursor-pointer" onClick={this.prevPage}>
                  chevron_left
                </span>
                <span className="material-icons fs-34 cursor-pointer" onClick={this.nextPage}>
                  chevron_right
                </span>
              </div>
            )}
          </div>
        </div>
        <View direction="row" gap={6}>
          {this.paginatedReports.map((report: Object, idx: number) => {
            return (
              <div
                className={classNames(
                  "cursor-pointer gs-card justify-content-around with-cover-text gs-container gs-hover",
                  {
                    "d-none": report.hidden,
                  },
                )}
                onClick={this.props.runReport(report)}
                key={report.name}
              >
                <div className="cover">
                  <Text className="cover-text">{this.props.t(this.coverText[report.name])}</Text>
                  <img src={`/assets/img/reports/${this.filterReportName(report.name)}.jpg`} />
                </div>
                <div className="p-2 fs-14">{report.name}</div>
              </div>
            );
          })}
        </View>
      </View>
    );
  }
}

export default localize()(StandartReportsLayout);
